import React, { useEffect } from "react";

import LandingHeader from "../header";

import "./termsAndConditions.css";
import Footer from "../footer";

function TermsAndConditions() {
  // Scrolls to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-conditions-wrapper">

      {/* Website Header */}
      <div className="terms-conditions-header">
        <LandingHeader />
      </div>


      {/* Page Title */}
      <div className="terms-conditions-title">
        <h1>Terms & Conditions</h1>

        <p>
          Last Updated: August 13, 2026
        </p>
      </div>


      {/* Terms Content */}
      <div className="terms-conditions-content">

        {/* 1 */}
        <section>
          <h2>1. Introduction</h2>

          <p>
            These Terms & Conditions ("Terms") govern your access to and
            use of the websites, applications, products, and services
            operated by HMW Communications Private Limited
            ("HMW Communications", "we", "us", or "our").
          </p>

          <p>
            These Terms apply to our products and services, including
            QuallyHire AI and NuJobs.
          </p>

          <p>
            By accessing or using our websites or services, you agree
            to be bound by these Terms. If you do not agree with these
            Terms, please do not use our services.
          </p>
        </section>


        {/* 2 */}
        <section>
          <h2>2. Our Services</h2>

          <p>
            HMW Communications provides technology platforms and
            services designed to support recruitment, hiring, job
            discovery, and related activities.
          </p>

          <p>
            Our services include, among others:
          </p>

          <ul>
            <li>
              <strong>QuallyHire AI</strong> – an AI-powered hiring
              and recruitment platform for employers, recruiters,
              staffing organizations, and other recruitment users.
            </li>

            <li>
              <strong>NuJobs</strong> – a job search and recruitment
              platform that enables candidates to discover and apply
              for job opportunities.
            </li>
          </ul>

          <p>
            Features, functionality, pricing, and availability may
            change from time to time.
          </p>
        </section>


        {/* 3 */}
        <section>
          <h2>3. User Accounts</h2>

          <p>
            Certain features of our services may require you to create
            an account.
          </p>

          <p>
            You are responsible for providing accurate and current
            information when creating an account and for keeping your
            account information up to date.
          </p>

          <p>
            You are responsible for maintaining the confidentiality
            of your login credentials and for activities performed
            through your account.
          </p>

          <p>
            You should notify us promptly if you believe that your
            account has been accessed or used without authorization.
          </p>
        </section>


        {/* 4 */}
        <section>
          <h2>4. Use of QuallyHire AI</h2>

          <p>
            QuallyHire AI provides technology that supports recruitment
            and hiring workflows.
          </p>

          <p>
            Users of QuallyHire AI may upload or process job descriptions,
            resumes, candidate information, applications, evaluations,
            and other recruitment-related information.
          </p>

          <p>
            Users are responsible for ensuring that they have the
            necessary rights, permissions, notices, and lawful basis
            to upload, process, and use such information.
          </p>

          <p>
            QuallyHire AI is a technology platform and does not act as
            the employer, recruiter, or decision-maker for users of the
            platform unless explicitly agreed otherwise.
          </p>
        </section>


        {/* 5 */}
        <section>
          <h2>5. Use of NuJobs</h2>

          <p>
            NuJobs provides job search and recruitment functionality
            for candidates and organizations.
          </p>

          <p>
            Candidates may create profiles, upload resumes, search
            for jobs, save jobs, and apply for available positions.
          </p>

          <p>
            Employers and recruitment organizations may publish job
            opportunities and review candidate information for
            legitimate recruitment purposes.
          </p>
        </section>


        {/* 6 */}
        <section>
          <h2>6. Job Listings</h2>

          <p>
            Job listings displayed through NuJobs may be submitted by
            employers, recruiters, staffing organizations, or other
            authorized users.
          </p>

          <p>
            We do not guarantee that every job listing is accurate,
            complete, current, available, or legitimate.
          </p>

          <p>
            Employers and recruiters are responsible for the accuracy
            and legality of the job information they publish.
          </p>

          <p>
            Candidates should independently verify employment
            opportunities and the identity of organizations before
            providing sensitive information or accepting employment.
          </p>
        </section>


        {/* 7 */}
        <section>
          <h2>7. Candidate Applications</h2>

          <p>
            When a candidate applies for a job, information submitted
            as part of the application may be made available to the
            relevant employer, recruiter, staffing organization, or
            other authorized party involved in the recruitment process.
          </p>

          <p>
            Candidates are responsible for ensuring that information
            submitted through their profiles, resumes, and applications
            is accurate and does not violate the rights of others.
          </p>
        </section>


        {/* 8 */}
        <section>
          <h2>8. AI and Automated Processing</h2>

          <p>
            Certain QuallyHire AI and related services may use
            artificial intelligence, automation, algorithms, or other
            technologies to assist users with recruitment-related
            activities.
          </p>

          <p>
            These technologies may assist with activities such as
            resume processing, job description analysis, candidate
            matching, ranking, recommendations, and recruitment
            workflows.
          </p>

          <p>
            AI-generated or automated results may contain errors,
            omissions, or inaccuracies.
          </p>

          <p>
            Users are responsible for reviewing and validating
            information and results before relying on them.
          </p>

          <p>
            HMW Communications does not make employment decisions on
            behalf of employers or recruiters. Final hiring and
            employment decisions remain the responsibility of the
            relevant employer or authorized decision-maker.
          </p>
        </section>


        {/* 9 */}
        <section>
          <h2>9. User Content</h2>

          <p>
            Users may provide or upload content including resumes,
            job descriptions, company information, profile information,
            applications, evaluations, documents, and other materials
            ("User Content").
          </p>

          <p>
            You retain ownership of your User Content, subject to the
            rights and permissions necessary for us to provide our
            services.
          </p>

          <p>
            By submitting User Content, you grant HMW Communications
            the limited rights necessary to store, process, display,
            transmit, and otherwise use the content to provide and
            improve the services, subject to our Privacy Policy and
            applicable agreements.
          </p>
        </section>


        {/* 10 */}
        <section>
          <h2>10. Prohibited Activities</h2>

          <p>
            You agree not to use our services to:
          </p>

          <ul>
            <li>
              Violate applicable laws or regulations.
            </li>

            <li>
              Submit false, misleading, fraudulent, or deceptive
              information.
            </li>

            <li>
              Post fraudulent, misleading, discriminatory, or unlawful
              job opportunities.
            </li>

            <li>
              Impersonate another person or organization.
            </li>

            <li>
              Attempt to gain unauthorized access to accounts,
              systems, or data.
            </li>

            <li>
              Upload malicious software, harmful code, or other
              destructive material.
            </li>

            <li>
              Scrape, copy, reproduce, or systematically collect
              platform data without authorization.
            </li>

            <li>
              Abuse, disrupt, or interfere with the operation of
              our services.
            </li>

            <li>
              Use candidate information for purposes unrelated to
              legitimate recruitment activities.
            </li>
            <li>
              Sell, resell, publish, distribute, disclose, or share
              candidate personal information with unauthorized third
              parties, except where necessary for legitimate recruitment
              or hiring activities and permitted by applicable law.
            </li>            
          </ul>
        </section>


        {/* 11 */}
        <section>
          <h2>11. Subscriptions, Payments and Refunds</h2>

          <p>
            Certain features and services offered through QuallyHire AI
            or NuJobs may require a paid subscription or other payment.
          </p>

          <p>
            Subscription pricing, billing periods, available features,
            and applicable charges will be displayed to you before
            completing your purchase.
          </p>


          <h3>11.1 Refund Policy</h3>

          <p>
            We provide a refund window of seven (7) days from the date
            of purchase for eligible subscription plans.
          </p>

          <p>
            Refund requests must be submitted within seven (7) days
            of the original purchase. Requests submitted after the
            seven (7) day period are not eligible for a refund.
          </p>

          <p>
            After the seven (7) day refund period has expired,
            subscription payments are non-refundable, including where
            a user chooses not to continue using the service or does
            not use all of the features included in the subscription.
          </p>

          <p>
            Where a refund is approved, the refund will generally be
            processed using the original payment method, subject to
            the policies and processing timelines of the applicable
            payment provider.
          </p>


          <h3>11.2 Subscription Cancellation</h3>

          <p>
            Users may stop using or cancel their subscription in
            accordance with the cancellation options provided through
            the applicable service.
          </p>

          <p>
            Cancellation of a subscription does not automatically
            create an entitlement to a refund for payments that are
            outside the applicable seven (7) day refund period.
          </p>


          <h3>11.3 Changes to Plans and Pricing</h3>

          <p>
            We reserve the right to modify subscription plans, features,
            pricing, or availability from time to time.
          </p>

          <p>
            Changes to pricing or subscription offerings will generally
            apply to future purchases or renewal periods unless
            otherwise required by applicable law.
          </p>
        </section>


        {/* 12 */}
        <section>
          <h2>12. Intellectual Property</h2>

          <p>
            The websites, software, platform interfaces, designs,
            trademarks, logos, text, graphics, and other materials
            provided by HMW Communications are owned by or licensed
            to HMW Communications and are protected by applicable
            intellectual property laws.
          </p>

          <p>
            Except as expressly permitted by us, you may not copy,
            reproduce, modify, distribute, sell, license, reverse
            engineer, or create derivative works from our services
            or platform materials.
          </p>
        </section>


        {/* 13 */}
        <section>
          <h2>13. Third-Party Services and Links</h2>

          <p>
            Our services may contain links to third-party websites,
            services, or applications.
          </p>

          <p>
            We do not control and are not responsible for the content,
            availability, security, or privacy practices of third-party
            services.
          </p>

          <p>
            Your use of third-party services may be subject to their
            own terms and privacy policies.
          </p>
        </section>


        {/* 14 */}
        <section>
          <h2>14. Availability of Services</h2>

          <p>
            We make reasonable efforts to keep our services available
            and operational. However, we do not guarantee that our
            services will always be available, uninterrupted, secure,
            or error-free.
          </p>

          <p>
            Services may occasionally be unavailable due to maintenance,
            upgrades, technical problems, security incidents, or factors
            outside our reasonable control.
          </p>
        </section>


        {/* 15 */}
        <section>
          <h2>15. Disclaimer</h2>

          <p>
            Our services are provided on an "as available" and, to the
            extent permitted by applicable law, "as is" basis.
          </p>

          <p>
            We do not guarantee the accuracy, completeness, reliability,
            availability, or suitability of information provided through
            our services.
          </p>

          <p>
            We do not guarantee that a candidate will obtain employment,
            that an employer will find a suitable candidate, or that a
            job listing will result in an interview or employment.
          </p>

          <p>
            We also do not guarantee the accuracy or completeness of
            AI-generated recommendations, matching results, evaluations,
            or other automated outputs.
          </p>
        </section>


        {/* 16 */}
        <section>
          <h2>16. Limitation of Liability</h2>

          <p>
            To the maximum extent permitted by applicable law,
            HMW Communications and its officers, employees, affiliates,
            service providers, and representatives will not be liable
            for indirect, incidental, special, consequential, or
            punitive damages arising from or related to your use of
            our services.
          </p>

          <p>
            Nothing in these Terms is intended to exclude or limit
            liability that cannot lawfully be excluded or limited
            under applicable law.
          </p>
        </section>


        {/* 17 */}
        <section>
          <h2>17. Indemnification</h2>

          <p>
            To the extent permitted by applicable law, you agree to
            indemnify and hold harmless HMW Communications and its
            affiliates, officers, employees, and representatives from
            claims, losses, liabilities, damages, and expenses arising
            from your violation of these Terms, misuse of our services,
            or violation of the rights of another person or organization.
          </p>
        </section>


        {/* 18 */}
        <section>
          <h2>18. Suspension or Termination</h2>

          <p>
            We may suspend or terminate access to our services where
            we reasonably believe that a user has violated these Terms,
            applicable law, or otherwise misused our services.
          </p>

          <p>
            Users may also stop using our services at any time, subject
            to any applicable subscription or contractual obligations.
          </p>

          <p>
            Certain provisions of these Terms may continue to apply
            after termination where their nature requires continued
            application.
          </p>
        </section>


        {/* 19 */}
        <section>
          <h2>19. Privacy</h2>

          <p>
            Your use of our services is also subject to our Privacy
            Policy, which explains how HMW Communications collects,
            uses, stores, and processes personal information.
          </p>

          <p>
            Please review our Privacy Policy for additional information
            regarding privacy and data handling.
          </p>
        </section>


        {/* 20 */}
        <section>
          <h2>20. Changes to These Terms</h2>

          <p>
            We may update these Terms from time to time to reflect
            changes in our services, technology, business practices,
            or applicable legal requirements.
          </p>

          <p>
            Updated Terms will be posted on this page with a revised
            "Last Updated" date.
          </p>

          <p>
            Your continued use of our services after updated Terms
            are posted constitutes acceptance of the updated Terms,
            to the extent permitted by applicable law.
          </p>
        </section>


        {/* 21 */}
        <section>
          <h2>21. Governing Law</h2>

          <p>
            These Terms shall be governed by and interpreted in
            accordance with the laws applicable to HMW Communications
            Private Limited, without regard to conflict-of-law
            principles.
          </p>

          <p>
            Any disputes shall be subject to the jurisdiction of the
            appropriate courts having jurisdiction over such matters,
            subject to applicable law.
          </p>
        </section>


        {/* 22 */}
        <section>
          <h2>22. Contact Us</h2>

          <p>
            If you have questions regarding these Terms & Conditions,
            please contact us at:
          </p>

          <div className="terms-contact">
            <strong>HMW Communications Private Limited</strong>

            <br />

            Email: support@hmwcomm.com

            <br />

            QuallyHire AI / NuJobs
          </div>
        </section>

      </div>


      {/* Website Footer */}
      <Footer />

    </div>
  );
}

export default TermsAndConditions;